import { render, staticRenderFns } from "./ProjectPreviewMini.vue?vue&type=template&id=2d4ffd43&lang=pug&"
import script from "./ProjectPreviewMini.vue?vue&type=script&lang=js&"
export * from "./ProjectPreviewMini.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPreviewMini.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports